import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6477e84bacb618f2abe16b852a382d89b from "./generated-13977638-ebe1-427d-b68a-de1f68ba0a65.json";

import acaa6fc701853b610a9fd96b5b2d911fbb from "./generated-b9952113-8f05-4ef6-8b5f-cfaa2416622c.json";

import ae067f36dd0a468f24c72e824068a8f28b from "./generated-e19c997a-91ca-4a99-b638-b0e2b0fe174d.json";

import ab7e56aad36d7aeaec66b0fe793dc5f39b from "./generated-d3bfb1de-7c54-45e1-bddc-29838407665b.json";

import a51bc30d4f9710728b855cefda8b0fb54b from "./generated-985a8e5c-786a-4d0d-a8ab-a2bcd275d70f.json";

import a9e2ced070b74d77f1d04b57ecf432decb from "./generated-897b6619-c460-42df-98fe-2b0e9ace5bb9.json";

import afd4afbe25749168781d16dbff263eef3b from "./generated-52e78584-01e9-465d-9eda-d85527f3098c.json";

import a0edb332ae3f86faf798aba2972519ceab from "./generated-7d7fa96e-f979-4fc3-b12a-252bd673808a.json";

import aafd28bb2a6f9292e460d9f1d06a1477cb from "./generated-11d41ae0-b738-44d6-8e20-1d191ea40177.json";

import a67f8a8c03b36f0bdf21d2e9ebde40697b from "./generated-69fa9471-6ec2-49b5-a8d6-227e84ff18b0.json";

import a700f365932221ec970b41f813d17ab0bb from "./generated-0d404cef-e6ae-46c9-bdde-3b629664d9e9.json";

import ad6593aa49475f22e973db3ebc9d2108ab from "./generated-d99fcce5-2bef-494e-ad46-9765b8c9bec6.json";

import af391c928a55ab122ca0a9f356b35e55cb from "./generated-e294af7a-6a0d-4432-a5df-9afa54349053.json";

import a978e43dd588051af3023e9b5d1198960b from "./generated-cb3e454a-732a-477c-ac34-3999ce4ce658.json";

import a83f78899dc801cbd838eac1c9a8574a0b from "./generated-1c566abc-2d6e-4ce7-9c39-353a44363647.json";

import a09af8dbfd528e316a278cc1b733d7cfbb from "./generated-4cc0e881-98b2-4c9d-8a76-9cfdc55763db.json";

import ad4f56e50b3724336160c29aedd5490a1b from "./generated-dfc48812-32fc-46ba-b4f7-c0bd07e990b2.json";

import aff66aa594abf7c47a80d733757386e61b from "./generated-052781c1-b745-4663-81bb-0de5b7e6a5f6.json";

import a8add1b35cfba22e8bdc5e4b0b1d2bad0b from "./generated-a302bc89-5051-4f3b-8b76-c0fbf18b9105.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6477e84bacb618f2abe16b852a382d89b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(acaa6fc701853b610a9fd96b5b2d911fbb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ae067f36dd0a468f24c72e824068a8f28b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ab7e56aad36d7aeaec66b0fe793dc5f39b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a51bc30d4f9710728b855cefda8b0fb54b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9e2ced070b74d77f1d04b57ecf432decb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(afd4afbe25749168781d16dbff263eef3b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a0edb332ae3f86faf798aba2972519ceab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aafd28bb2a6f9292e460d9f1d06a1477cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a67f8a8c03b36f0bdf21d2e9ebde40697b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a700f365932221ec970b41f813d17ab0bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ad6593aa49475f22e973db3ebc9d2108ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(af391c928a55ab122ca0a9f356b35e55cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a978e43dd588051af3023e9b5d1198960b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a83f78899dc801cbd838eac1c9a8574a0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a09af8dbfd528e316a278cc1b733d7cfbb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ad4f56e50b3724336160c29aedd5490a1b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aff66aa594abf7c47a80d733757386e61b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a8add1b35cfba22e8bdc5e4b0b1d2bad0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ad4f56e50b3724336160c29aedd5490a1b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */